import { AppState } from 'app/store';

export const getIsWebSocketLive = (state: AppState) =>
  state.webSockets.isWebSocketLive;

export const getWebSocketConnectionUrl = (state: AppState) =>
  state.webSockets.connectionUrl;

export const getConnectionUrlLoadingState = (state: AppState) =>
  state.webSockets.connectionUrlLoadingState;

export const getIsSubscribedToResource = (resource: string) => (
  state: AppState
) => state.webSockets.subscriptionResource === resource;

export const getActivityPingInterval = (state: AppState) =>
  state.webSockets.activityPingInterval;
